import { CompanySettingsAction, STORE_COMPANY_SETTINGS } from '@Actions/companySettings';

import { ICompanySettings } from '@ClientApi/companySettings';

interface ICompanySettingsState {
  settings: ICompanySettings | null;
  loaded: boolean;
}

const defaultState: ICompanySettingsState = {
  settings: null,
  loaded: false
};

export function companySettingsReducer(state: ICompanySettingsState = defaultState, action: CompanySettingsAction): ICompanySettingsState {
  if (action.type === STORE_COMPANY_SETTINGS) {
    return { settings: action.settings, loaded: true };
  }
  return state;
}
